import { defineStore } from 'pinia';
import { store } from '/@/store';

let timer;
export const useStoreExtensionStore = defineStore({
  id: 'store-extension',
  state: () => ({
    isInstallStoreExtension: false,
    storeExtensionInfo: undefined as undefined | any,
  }),
  getters: {},
  actions: {
    handle(e) {
      clearTimeout(timer);
      this.isInstallStoreExtension = true;
      this.storeExtensionInfo = e.detail;
      timer = setTimeout(() => {
        this.isInstallStoreExtension = false;
        this.storeExtensionInfo = undefined;
      }, 3000);
    },

    init() {
      document.addEventListener('lingtuStoreExtensionReady', this.handle);
    },
  },
});

export function useStoreExtensionStoreWithOut() {
  return useStoreExtensionStore(store);
}
